import React from "react";
import ReactECharts from "echarts-for-react";

import { getRandomColor } from "../../../Utilities/Functions";
import { Card, makeStyles } from "@material-ui/core";
import styles from "./styles";

const useStyles = makeStyles(styles);

const LineChart = (props) => {
  const { title, series, categories, legends, handleIntervals } = props;
  const classes = useStyles();

  const options = {
    title: {
      text: title,
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      top: "bottom",
      data: legends || (series || []).map((item) => item["name"]),
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: categories,
      axisLabel: {
        interval: handleIntervals
      }
    },
    yAxis: {
      type: "value",
    },
    series: (series || []).map((s) => ({
      name: s["name"],
      type: "line",
      stack: s["name"],
      data: s["data"],
      itemStyle: { color: s["color"] || getRandomColor() },
    })),
  };

  return (
    <Card className={classes.container} variant="outlined" elevation={0}>
      <ReactECharts option={options} />;
    </Card>
  )
};

export default LineChart;
